import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { getAllUsers, getBookings, getServices } from "../../helpers/lib/axios";
import { IsTokenExpired } from "../../helpers/lib/jwt";
import { useEffect, useState } from "react";
import Section from "../Section";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";

const Admin = () => {
    const navigate = useNavigate()

    const [users, setUsers] = useState(null);
    const [services, setServices] = useState(null);
    const [bookings, setBookings] = useState(null);

    useEffect(() => {
        const token = Cookies.get('noohraToken')
        if (!token) {
            navigate('/signup')
            return;
        }
        if (IsTokenExpired(token)) {
            Cookies.remove("noohraToken");
            console.log('token expired')
            setUsers(null)
            navigate('/signup')
            return;
        } else {
            getServices().then(user => {
                console.log(user)
                setServices(user?.data);
            }).catch(err => console.log(err))
            getAllUsers().then(user => {
                console.log(user)
                setUsers(user?.data);
            }).catch(err => console.log(err))
            getBookings().then(user => {
                console.log(user)
                setBookings(user?.data);
            }).catch(err => console.log(err))
        }
    }, [navigate])

    return (<>
        <BannerSectionStyle2
            bgUrl="/images/about/banner_bg.svg"
            imgUrl="/images/about/banner_img.png"
            title="Admin"
            subTitle="Admin Overview"
        />
        <Section
            topMd={170}
            topLg={150}
            topXl={110}
            bottomMd={200}
            bottomLg={150}
            bottomXl={110}
            className='flex justify-center items-center w-full'
        >
            <div className="lg:max-w-[70%] w-full mt-[5%] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
                <div
                    className={`relative overflow-hidden rounded-xl bg-blue-50 p-6`}
                >
                    {/* Decorative circle in background */}
                    <div className={`absolute -right-6 -top-6 h-24 w-24 rounded-full bg-blue-500 opacity-10`}></div>

                    <div className="relative">
                        <p className={`text-3xl font-bold text-blue-500`}>
                            {users && users?.length}
                        </p>
                        <p className="mt-1 text-sm text-gray-600">
                            Total Users
                        </p>
                    </div>
                </div>
                <div
                    className={`relative overflow-hidden rounded-xl bg-green-50 p-6`}
                >
                    {/* Decorative circle in background */}
                    <div className={`absolute -right-6 -top-6 h-24 w-24 rounded-full bg-green-500 opacity-10`}></div>

                    <div className="relative">
                        <p className={`text-3xl font-bold text-green-500`}>
                            {services && services?.length}
                        </p>
                        <p className="mt-1 text-sm text-gray-600">
                            Total Services
                        </p>
                    </div>
                </div>
                <div
                    className={`relative overflow-hidden rounded-xl bg-purple-50 p-6`}
                >
                    {/* Decorative circle in background */}
                    <div className={`absolute -right-6 -top-6 h-24 w-24 rounded-full bg-purple-500 opacity-10`}></div>

                    <div className="relative">
                        <p className={`text-3xl font-bold text-purple-500`}>
                            {bookings && bookings?.length}
                        </p>
                        <p className="mt-1 text-sm text-gray-600">
                            Total Appointments
                        </p>
                    </div>
                </div>
            </div>
        </Section>
    </>);
}

export default Admin;